// extracted by mini-css-extract-plugin
export default {"H1":"maintenance_H1__Id+Tc","H2":"maintenance_H2__MfDJU"};